import { atom } from '@exodus/headless-ui';
const fiatModeAtom = atom(false);
export default fiatModeAtom;
